var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items && _vm.items.length
    ? _c(
        "div",
        { staticClass: "accordion-help-items" },
        [
          _c("h2", [
            _c(
              "svg",
              {
                attrs: {
                  width: "36",
                  height: "35",
                  viewBox: "0 0 36 35",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("g", { attrs: { "clip-path": "url(#clip0)" } }, [
                  _c("path", {
                    attrs: {
                      d:
                        "M35.9914 19.4493C35.9857 17.7163 34.9764 16.7203 33.2433 16.7028C32.3834 16.6932 31.5178 16.6468 30.6617 16.7125C29.9684 16.7667 29.8325 16.523 29.8382 15.8615C29.8727 12.3839 29.8593 8.90638 29.8516 5.42882C29.8459 3.2626 28.6087 2.00735 26.4772 2.00348C22.6202 1.99768 18.7613 2.00155 14.9043 2.00155C11.0147 2.00155 7.12516 1.99381 3.2356 2.00542C1.39136 2.00929 0.0354673 3.22585 0.0258918 4.98978C-0.00666482 10.2061 -0.00474972 15.4225 0.0239768 20.6388C0.0335522 22.3254 1.34539 23.5787 3.0326 23.6367C3.63777 23.658 4.24677 23.6773 4.84811 23.6328C5.44753 23.5864 5.67543 23.7276 5.59308 24.4065C5.35752 26.3213 5.19857 28.2476 5.00323 30.1682C4.95535 30.6402 4.95727 31.0986 5.47052 31.3132C5.94163 31.5105 6.24421 31.1856 6.54105 30.8839C8.20719 29.1973 10.0093 27.6229 11.5069 25.7952C12.9739 24.0042 14.6534 23.3021 16.8845 23.6174C17.436 23.6947 17.6448 23.7527 17.6276 24.3678C17.5816 26.0079 17.6046 27.6519 17.6142 29.294C17.6237 31.0947 18.6081 32.0966 20.3891 32.112C22.2066 32.1275 24.024 32.1527 25.8414 32.1217C26.5481 32.1101 27.0958 32.2687 27.6186 32.7948C28.5647 33.7502 29.5893 34.6245 30.5851 35.5277C30.9164 35.8275 31.2362 36.1872 31.7514 35.8875C32.2417 35.6031 32.1651 35.1389 32.1191 34.6883C32.0808 34.3034 32.0176 33.9224 31.987 33.5375C31.8759 32.1469 31.8797 32.1469 33.2433 32.1352C34.9803 32.1217 35.9876 31.1372 35.9933 29.3985C36.0048 26.0814 36.0029 22.7644 35.9914 19.4493ZM17.6142 19.459C17.6084 20.0702 17.5605 20.6891 17.6256 21.2925C17.7022 22.0082 17.4092 22.2093 16.7734 22.0971C14.1134 21.6291 12.0872 22.5613 10.4344 24.7275C9.41562 26.0621 8.08845 27.1568 6.71916 28.5416C6.89535 26.7719 7.02749 25.2652 7.20176 23.7643C7.37221 22.2847 7.23624 22.101 5.80183 22.0991C5.00515 22.0991 4.20655 22.1049 3.40987 22.0971C2.03674 22.0855 1.5369 21.571 1.53499 20.1495C1.53307 15.2542 1.53116 10.3589 1.5369 5.46364C1.53882 4.07107 2.05781 3.54498 3.44243 3.54498C10.7447 3.54111 18.047 3.54305 25.3492 3.54305C25.828 3.54305 26.3068 3.52371 26.7836 3.54885C27.701 3.59914 28.3061 4.1465 28.3119 5.06327C28.3387 8.76713 28.3138 12.471 28.3387 16.1748C28.3425 16.7338 28.0495 16.697 27.6818 16.6951C25.2592 16.6854 22.8347 16.6777 20.4121 16.6796C18.6023 16.6816 17.6333 17.6486 17.6142 19.459ZM34.4708 29.354C34.4728 30.1914 34.1242 30.617 33.272 30.5957C32.6668 30.5802 32.0616 30.5879 31.4546 30.5937C30.3744 30.6054 30.1868 30.8181 30.2729 31.9322C30.3017 32.3093 30.3476 32.6845 30.407 33.2706C29.505 32.4524 28.7198 31.7658 27.9672 31.0483C27.6186 30.7156 27.2509 30.5821 26.7721 30.5841C24.6694 30.5976 22.5647 30.5841 20.4619 30.5667C19.4335 30.5589 19.1443 30.2746 19.1424 29.2573C19.1347 26.006 19.1501 22.7547 19.1328 19.5035C19.1271 18.6176 19.4737 18.2095 20.3776 18.2153C24.6483 18.2405 28.919 18.2463 33.1916 18.2405C34.0648 18.2385 34.4766 18.5964 34.4728 19.5054C34.4555 22.7876 34.4594 26.0698 34.4708 29.354Z",
                      fill: "#926D20"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M18.3724 9.35962C18.3379 11.1235 17.6944 12.6244 16.3692 13.7733C15.2546 14.7384 14.4541 15.8177 14.5364 17.392C14.5613 17.8698 14.2683 18.2102 13.7819 18.2024C13.2457 18.1947 13.0178 17.8311 13.0197 17.2992C13.0235 15.5121 13.7551 14.0692 15.0746 12.9203C15.967 12.1448 16.666 11.2802 16.8154 10.0385C17.0184 8.3558 16.3117 7.21854 14.7203 6.76402C13.1346 6.3095 11.4148 7.00385 10.8077 8.35C10.756 8.46605 10.7369 8.59757 10.6909 8.71555C10.5205 9.1546 10.2083 9.44665 9.73911 9.29772C9.23353 9.13719 9.08415 8.70201 9.24119 8.20688C9.78699 6.4681 11.0471 5.54552 12.7477 5.1761C15.651 4.54558 18.3973 6.59768 18.3724 9.35962Z",
                      fill: "#926D20"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M14.554 19.8137C14.4544 20.2721 14.192 20.568 13.7132 20.5255C13.29 20.4887 13.02 20.2141 13.0295 19.7692C13.0391 19.2857 13.3206 18.9975 13.8013 19.0091C14.2878 19.0207 14.5099 19.3437 14.554 19.8137Z",
                      fill: "#926D20"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M25.6484 23.1981C25.6484 22.2329 25.6503 21.2678 25.6465 20.3027C25.6445 19.7766 25.859 19.4033 26.4068 19.4033C26.9545 19.4033 27.1747 19.7805 27.1747 20.3027C27.1747 22.2658 27.1728 24.229 27.1747 26.1902C27.1747 26.7182 26.9449 27.0876 26.4068 27.0895C25.8648 27.0915 25.6426 26.7201 25.6445 26.1902C25.6522 25.1922 25.6484 24.1942 25.6484 23.1981Z",
                      fill: "#926D20"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M26.3523 27.8809C26.8464 27.9118 27.1528 28.1652 27.1605 28.6429C27.17 29.1226 26.8713 29.4146 26.3963 29.4165C25.9654 29.4185 25.6878 29.1535 25.6571 28.7164C25.6226 28.2271 25.908 27.9698 26.3523 27.8809Z",
                      fill: "#926D20"
                    }
                  })
                ]),
                _c("defs", [
                  _c("clipPath", { attrs: { id: "clip0" } }, [
                    _c("rect", {
                      attrs: {
                        width: "36",
                        height: "34",
                        fill: "white",
                        transform: "translate(0 0.996094)"
                      }
                    })
                  ])
                ])
              ]
            ),
            _vm._v(
              "\n        " + _vm._s(_vm.$t("front.faq_schema.title")) + "\n    "
            )
          ]),
          _vm._l(_vm.items, function(helpItem, index) {
            return _c("CollapseContentBlockWithTitle", {
              key: index,
              attrs: { componentContent: _vm.componentContent(helpItem) }
            })
          }),
          _c("script", {
            attrs: { type: "application/ld+json" },
            domProps: { innerHTML: _vm._s(_vm.jsonLdFaqPageType) }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }